<!-- 版本购买 -->
<template>
    <div class="content">
        <div class="card-div">
            <div v-for="(item, index) in data_array" :key="index" class="card">
                <div
                    class="card-border"
                    :style="`background: ${item.bg_color};`"
                ></div>
                <div class="card-version">{{ item.title }}</div>
                <div class="card-money">
                    <div v-html="item.price_title"></div>
                </div>
                <div class="p24">
                    <div
                        class="card-btn"
                        :style="`background: ${item.bg_color};`"
                        @click="openMoney(item)"
                    >
                        {{ item.btn_title }}
                    </div>
                    <div v-if="item.sub_title" v-html="item.sub_title"></div>
                    <div class="intro-txt-content">
                        <div
                            v-for="(e, i) in item.intro"
                            :key="i"
                            class="flex-between"
                        >
                            <div class="intro-txt">
                                <div v-html="e.key"></div>
                            </div>
                            <div class="intro-txt">
                                {{ e.value }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 版本对比 -->
        <div class="compare-container">
            <div class="compare-container-title">版本对比</div>
            <div
                class="compare-container-table"
                v-for="(item, index) in compare_data"
                :key="index"
            >
                <div
                    :class="
                        index == 0
                            ? 'compare-container-box-one'
                            : 'compare-container-box'
                    "
                    v-for="(e, i) in item"
                    :key="i"
                >
                    <div :class="i == 0 ? 'compare-card-one' : 'compare-card'">
                        <img
                            v-if="e == 1"
                            src="@/assets/version/check-mark.png"
                            class="compare-card-img"
                        />
                        <div v-else-if="e == 0">---</div>
                        <div v-else>{{ e }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 升级版本 -->
        <Modal
            v-model="money_modal"
            width="800"
            :closable="false"
            @on-cancel="cancelMoneyModal"
        >
            <div slot="header">
                <div
                    class="money-header"
                    :style="`background: ${money_data.bg_color};`"
                >
                    <div class="money-header-title">升级版本</div>
                    <div>当前版本: {{ money_data.title }}</div>
                </div>
            </div>
            <div class="flex-div">
                <div class="money-card1">
                    <div class="money-card1-title">{{ money_data.title }}</div>
                    <div>满足中小型组织多业务团队日常使用</div>
                    <div
                        v-if="money_data.sub_title"
                        v-html="money_data.sub_title"
                    ></div>
                    <div class="intro-txt-content">
                        <div
                            v-for="(item, index) in money_data.intro"
                            :key="index"
                        >
                            <div class="flex-between">
                                <div class="intro-txt">
                                    <div v-html="item.key"></div>
                                </div>
                                <div class="intro-txt">
                                    {{ item.value }}
                                </div>
                            </div>
                            <div
                                v-for="(e, i) in item.desc"
                                :key="i"
                                class="intro-txt ml10 mb3"
                            >
                                {{ e }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="money-div">
                    <div class="money-title">订单详情</div>
                    <div class="money-text">
                        订单类型: {{ info_data.encapsulate }}
                    </div>
                    <div class="money-text">
                        订购版本: {{ money_data.title }}
                    </div>
                    <div class="money-text">订购时长: {{ info_data.days }}</div>
                    <div class="money-text">预期生效时间：付款后立即生效</div>
                    <div class="money-card2">
                        <div class="money-card2-title">支付方式</div>
                        <div class="money-flex">
                            <div class="money-img-container">
                                <img
                                    v-if="loading"
                                    src="@/assets/loading.gif"
                                    alt="加载中"
                                    class="loading-img-container"
                                />
                                <VueQr
                                    v-else-if="qrcode_data"
                                    id="vueQr"
                                    :text="qrcode_data"
                                ></VueQr>
                            </div>
                            <div class="money-right">
                                <div class="money-right-title">在线支付</div>
                                <div class="money-right-btn-div">
                                    <!-- <div :class="money_value == 2 ? 'money-right-btn-active2' : 'money-right-btn'" @click="changeMoney(2)">
                                        <img v-if="money_value == 2" src="@/assets/version/alipay-active.png" alt="" class="money-right-img">
                                        <img v-else src="@/assets/version/alipay.png" alt="" class="money-right-img">
                                        <div>支付宝支付</div>
                                    </div>
                                    <div> | </div> -->
                                    <div
                                        :class="
                                            money_value == 1
                                                ? 'money-right-btn-active1'
                                                : 'money-right-btn'
                                        "
                                        @click="changeMoney(1)"
                                    >
                                        <img
                                            v-if="money_value == 1"
                                            src="@/assets/version/wechat-active.png"
                                            alt=""
                                            class="money-right-img"
                                        />
                                        <img
                                            v-else
                                            src="@/assets/version/wechat.png"
                                            alt=""
                                            class="money-right-img"
                                        />
                                        <div>微信支付</div>
                                    </div>
                                </div>
                                <div>应支付金额</div>
                                <div class="money-p-div">
                                    <div class="money-p">
                                        ￥{{ info_data.price }}
                                    </div>
                                    <div
                                        v-if="info_data.original_price"
                                        class="money-span"
                                    >
                                        原价￥{{ info_data.original_price }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>

<script>
import {
    version,
    version_buy,
    version_query,
    account_v_m,
    version_compare,
} from "@/api/index";
import VueQr from "vue-qr";
export default {
    components: { VueQr },
    data() {
        return {
            data_array: [],
            money_modal: false,
            money_data: {},
            money_value: 1,
            qrcode_data: "",
            order_id: "",
            timer: null, // 存储定时器ID
            info_data: {
                days: "",
                encapsulate: "",
                price: "",
                original_price: "",
            },
            loading: false,
            compare_data: [],
        };
    },
    mounted() {
        this.getVersion();
        this.getVersionCompare();
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        this.clearInterval();
    },
    methods: {
        getVersionCompare() {
            version_compare()
                .then((res) => {
                    this.compare_data = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getVersion() {
            version().then((res) => {
                this.data_array = res.data;
            });
        },
        openMoney(e) {
            if (e.version_id == 1) {
                return;
            }
            if (e.link) {
                window.open(e.link);
            } else {
                this.loading = true;
                this.money_data = e;
                this.getVersionBuy();
            }
        },
        changeMoney(i) {
            this.money_value = i;
            this.clearInterval();
            this.getVersionBuy();
        },
        getVersionBuy() {
            var data = {
                version_id: this.money_data.version_id,
                pay_type: this.money_value,
            };
            version_buy(data)
                .then((res) => {
                    // 0元购
                    if(res.data && res.data.code && res.data.code == 200){
                        this.$Message.success(res.data.msg);
                        return
                    }
                    this.qrcode_data = res.data.data;
                    this.order_id = res.data.order_id;
                    this.info_data.days = res.data.days;
                    this.info_data.encapsulate = res.data.encapsulate;
                    this.info_data.price = res.data.price;
                    this.info_data.original_price = res.data.original_price;
                    setTimeout(() => {
                        this.loading = false;
                    }, 300);
                    this.startInterval();
                    this.money_modal = true;
                })
                .catch((res) => {
                    this.qrcode_data = "";
                    this.$Message.error(res.msg);
                });
        },
        goVersionQuery() {
            version_query({ order_id: this.order_id }).then((res) => {
                // 0 未付款 1 付款成功
                if (res.data == 1) {
                    this.$Message.success("支付成功");
                    this.money_modal = false;
                    this.clearInterval();
                    this.getAccountvm();
                }
            });
        },
        // 启动定时器
        startInterval() {
            this.timer = setInterval(() => {
                this.goVersionQuery();
            }, 5000);
        },
        // 清除定时器
        clearInterval() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        cancelMoneyModal() {
            this.clearInterval();
        },
        getAccountvm() {
            account_v_m().then((res) => {
                this.$store.commit("setMenus", res.data.menu);
                localStorage.setItem("IDENTITYS", res.data.identitys);
                if (res.data.version) {
                    localStorage.setItem("SUYUANPCNAME", res.data.version.name);
                    localStorage.setItem(
                        "SUYUANPCQRCODENUMS",
                        res.data.version.qrcode_nums
                    );
                    localStorage.setItem(
                        "SUYUANPCREMAININGNUMS",
                        res.data.version.remaining_nums
                    );
                    localStorage.setItem(
                        "SUYUANPCENDDATE",
                        res.data.version.end_date
                    );
                }
                localStorage.setItem("app_ids", res.data.app_ids);
            });
        },
    },
};
</script>

<style scoped>
.content {
    padding: 36px 0 0 36px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.card-div {
    display: flex;
    flex-wrap: wrap;
}
.card {
    margin: 0 36px 36px 0;
    padding-bottom: 24px;
    min-width: 280px;
    width: 280px;
    max-width: 280px;
    min-height: 400px;
    background: #ffffff;
    box-shadow: 0px 0px 24px 0px #dcdcdc;
    border-radius: 10px;
    text-align: center;
}
.card-border {
    width: 100%;
    height: 18px;
    border-radius: 10px 10px 0px 0px;
}
.card-btn {
    width: 100%;
    margin: 12px auto 0 auto;
    border-radius: 5px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    height: 40px;
    line-height: 40px;
}
::v-deep .card-btn-tip {
    width: 100%;
    margin: 6px auto 0 auto;
    border-radius: 10px;
    text-align: left;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    padding-left: 12px;
    height: 30px;
    line-height: 30px;
}
/* ::v-deep .card-btn2-tip {
    width: 100%;
    margin: 6px auto 0 auto;
    background: rgba(255,227,208,0.26);
    border-radius: 10px;
    text-align: left;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #FF761D ;
    padding-left: 12px;
    height: 30px;
    line-height: 30px;
}
::v-deep .card-btn3-tip {
    width: 100%;
    margin: 6px auto 0 auto;
    background: rgba(203,255,203,0.26);
    border-radius: 10px;
    text-align: left;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #179958;
    padding-left: 12px;
    height: 30px;
    line-height: 30px;
}
::v-deep .card-btn4-tip {
    width: 100%;
    margin: 6px auto 0 auto;
    background: rgba(54,112,247,0.09);
    border-radius: 10px;
    text-align: left;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #3670F7;
    padding-left: 12px;
    height: 30px;
    line-height: 30px;
}
::v-deep .card-btn5-tip {
    width: 100%;
    margin: 6px auto 0 auto;
    background: rgba(38,38,38,0.09);
    border-radius: 10px;
    text-align: left;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #262626;
    padding-left: 12px;
    height: 30px;
    line-height: 30px;
} */
.card-version {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 27px;
    color: #010101;
    margin: 12px 0;
}
.card-money {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 35px;
    color: #010101;
}
::v-deep .card-money-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #010101;
}
.p24 {
    padding: 0 24px;
}
.flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin-bottom: 3px;
}
.padding-left-12 {
    padding-left: 12px;
}
.flex-div {
    display: flex;
}
.money-div {
    margin-left: 20px;
}
.money-title {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 18px;
    color: #010101;
    margin: 20px 0;
}
.money-text {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin-bottom: 10px;
}
.money-card1 {
    width: 280px;
    background: #f9fef9;
    border-radius: 10px;
    border: 1px solid #d2d5e0;
    padding: 10px 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}
.money-card1-title {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 20px;
    color: #010101;
    margin-bottom: 6px;
}
.money-card2 {
    margin-top: 20px;
    width: 460px;
    background: #f9fef9;
    border-radius: 10px;
    border: 1px solid #d2d5e0;
    padding: 20px 10px;
}
.card-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 11px;
    color: #666666;
}
.compare-container {
    padding: 0 36px 36px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.compare-container-title {
    margin-bottom: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 44px;
    color: #484e66;
}
.compare-container-table {
    display: flex;
    width: 100%;
}
.compare-container-box-one {
    width: 16.6%;
    height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.compare-container-box {
    width: 16.6%;
    height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
}
.compare-card-one {
    padding: 12px 0;
    width: 100%;
    height: 100%;
    background: #ffffff;
    border: 1px solid #ababab;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #ff761d;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.compare-card {
    padding: 12px 0;
    width: 100%;
    height: 100%;
    background: #ffffff;
    border: 1px solid #ababab;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.compare-card-img {
    width: 20px;
    height: 20px;
}
.money-flex {
    display: flex;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}
.money-img-container {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    height: 200px;
    min-height: 200px;
    max-height: 200px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
}
.loading-img-container {
    width: 50px;
    height: 50px;
}
.intro-txt-content {
    margin-top: 12px;
}
.intro-txt {
    white-space: nowrap;
}
.money-header {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #fff;
    padding: 14px 16px;
    border-radius: 6px 6px 0 0;
}
.money-header-title {
    font-size: 16px;
    margin-bottom: 10px;
}
.ml10 {
    margin-left: 10px;
}
.mb3 {
    margin-bottom: 3px;
}
.money-card2-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #010101;
    margin-bottom: 20px;
}
.money-right {
    margin-left: 20px;
    margin-top: 20px;
    width: 100%;
}
.money-right-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #010101;
    margin-bottom: 10px;
}
.money-right-btn-div {
    padding: 3px;
    border-radius: 4px;
    border: 1px solid #d2d5e0;
    width: 110px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}
.money-right-btn {
    background: #e6e6e6;
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #afafaf;
    padding: 0 10px;
    cursor: pointer;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.money-right-btn-active2 {
    background: rgba(125, 188, 253, 0.4);
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #0680ff;
    padding: 0 10px;
    cursor: pointer;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.money-right-btn-active1 {
    background: rgba(69, 204, 81, 0.24);
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #27b133;
    padding: 0 10px;
    cursor: pointer;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.money-p-div {
    display: flex;
    align-items: center;
    margin-top: 3px;
}
.money-p {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #de0000;
}
.money-span {
    margin-left: 24px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    font-size: 14px;
    color: #999999;
    text-decoration: line-through;
}
::v-deep .ivu-modal-header {
    padding: 0px;
}
::v-deep .intro-spn {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
}
.money-right-img {
    width: 22px;
    height: 22px;
    margin-right: 12px;
}
</style>